import React, { useRef } from 'react'

// third party components
import { Disclosure } from '@headlessui/react'

// images and icons
import SolanaLogoIcon from 'assets/icons/solana-logo-dark-small.svg?component'
import DownArrowIcon from 'assets/icons/down-arrow-icon.svg?component'
import DefaultAvatar from 'assets/images/dashboard-avatar.png'

// styles
import styles from './index.module.scss'
import { useRouter } from 'next/router'
import { getDisplayUserName } from 'utils/strings'
import ImageWithFoster from 'components/ImageWithFoster'
import Image from 'next/image'

const CollectorsAccordion = props => {
  const { data } = props
  const router = useRouter()
  const buttonRefs = useRef<any>([])
  const openedRef = useRef<any | null>(null)
  const clickRecent = index => {
    const clickedButton = buttonRefs.current[index]
    if (clickedButton === openedRef.current) {
      openedRef.current = null
      return
    }
    if (Boolean(openedRef.current?.getAttribute('data-value'))) {
      openedRef.current?.click()
    }
    openedRef.current = clickedButton
  }

  return (
    <div className="w-full flex flex-wrap gap-[10px]">
      {data.map((item, index) => (
        <div key={index} className="w-full flex flex-wrap">
          <Disclosure>
            {({ open }) => (
              <>
                <Disclosure.Button
                  className={open ? styles.activeButton : styles.button}
                  data-value={open}
                  ref={ref => {
                    buttonRefs.current[index] = ref
                  }}
                  onClick={() => clickRecent(index)}
                >
                  <div className="flex items-center gap-x-4">
                    <div className={styles.imageArea}>
                      {item.pfp_url !== null && item.pfp_url !== '' ? (
                        <ImageWithFoster src={item.pfp_url} className="rounded-full object-cover" />
                      ) : (
                        <Image src={DefaultAvatar} className="rounded-full object-cover" alt="" />
                      )}
                    </div>
                    <div className="block">
                      <div className={styles.subTitle} onClick={() => router.push(`/${item.collector_name}`)}>
                        {getDisplayUserName(item.collector_name)}
                      </div>
                      <div className="flex gap-2 mt-1 items-center">
                        <div className={styles.priceText}>Total Purchases</div>
                        <div className="flex items-center gap-[4px] mt-[2px]">
                          <SolanaLogoIcon alt="" />
                          <div className={styles.priceValue}>{parseFloat(item.purchase_volume).toFixed(2)}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <DownArrowIcon className={`${open ? 'rotate-180 transform' : ''} mt-1 mr-1`} />
                </Disclosure.Button>
                <Disclosure.Panel className={styles.panel}>
                  <div className={styles.firstRow}>
                    <div className={styles.title}>Highest Purchase</div>
                    <div className={styles.text}>
                      <div className="flex items-center gap-[10px]">
                        <SolanaLogoIcon alt="" />
                        {item.highest_purchase}
                      </div>
                    </div>
                  </div>
                  <div className={styles.secondRow}>
                    <div className={styles.title}>Favorite Category</div>
                    <div className={styles.text}>{item.favorite_category}</div>
                  </div>
                  <div className={styles.firstRow}>
                    <div className={styles.title}>Creators Supported</div>
                    <div className={styles.text}>{item.creators_supported}</div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      ))}
    </div>
  )
}

export default CollectorsAccordion
